import { render } from "./round-icon.vue?vue&type=template&id=34f65477&scoped=true"
import script from "./round-icon.js?vue&type=script&lang=js&external"
export * from "./round-icon.js?vue&type=script&lang=js&external"

import "./round-icon.scss?vue&type=style&index=0&id=34f65477&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f65477"]])

export default __exports__